import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, null, -1)
const _hoisted_3 = { class: "w-full flex justify-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "my-5 py-5" }, null, -1)

import { useRoute } from "vue-router";
import AuthForm from "@/components/form/AuthForm.vue"; // @ is an alias to /src
import LogoProject from "@/components/videntity/LogoProject.vue"; // @ is an alias to /src
import ButtonsAuth from "@/components/form/ButtonsAuth.vue"; // @ is an alias to /src
import { computed, Ref, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

const route = useRoute();

const name = computed(() => route.name);
let isLogging: Ref<boolean> = ref(name.value == "login");
watch(name, (name) => {
  isLogging.value = name == "login";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LogoProject),
      _hoisted_2,
      _createVNode(AuthForm, { "is-logging": _unref(isLogging) }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ButtonsAuth, { "is-logging": _unref(isLogging) }, null, 8, ["is-logging"])
          ])
        ]),
        _: 1
      }, 8, ["is-logging"])
    ]),
    _hoisted_4
  ], 64))
}
}

})